'use client';

import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { BRAND } from '@/lib/brand';

const faqs = [
  {
    q: `Wat heb ik nodig om ${BRAND.productName} te gebruiken?`,
    a: 'Een scherm met internetverbinding en een player-apparaat. We ondersteunen Raspberry Pi 4, Android sticks, Apple TV en BrightSign players. We sturen je gratis een config-script om je player binnen 5 minuten te koppelen.',
  },
  {
    q: 'Kan ik tussentijds opzeggen?',
    a: `Ja, altijd. ${BRAND.productName} heeft geen lange contracten. Je betaalt per maand en kunt elke maand opzeggen. Bij Enterprise geldt de afgesproken contracttermijn.`,
  },
  {
    q: 'Wat gebeurt er bij internetstoringen?',
    a: 'Niets. Onze players cachen alle content lokaal en blijven gewoon afspelen, ook zonder verbinding. Zodra het internet terug is, syncen ze automatisch nieuwe content.',
  },
  {
    q: 'Kan ik content plannen voor specifieke tijden of dagen?',
    a: 'Ja. Je kunt presentaties plannen op tijd, dag, datum, of zelfs op basis van triggers zoals het weer. Bijvoorbeeld: lunchmenu om 11:00, sluitingstijd om 21:00, of "regenkleding promo wanneer het regent".',
  },
  {
    q: 'Is mijn data veilig?',
    a: 'Ja. Alle data wordt versleuteld opgeslagen in EU-datacenters. We zijn GDPR-compliant en doen jaarlijks SOC2-audits. Bij Enterprise kunnen we ook hosten in jouw eigen cloud.',
  },
  {
    q: 'Bieden jullie ook hardware aan?',
    a: 'Wij leveren primair software, maar kunnen je adviseren over geschikte hardware en doorverwijzen naar onze partners voor schermen en players. Bij Enterprise pakketten is dit deel van het traject.',
  },
];

export function Faq() {
  return (
    <section id="faq" className="max-w-[800px] mx-auto px-6 py-24">
      <div className="text-center mb-12">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-primary font-medium">
          — Veelgestelde vragen
        </span>
        <h2 className="text-4xl md:text-5xl font-bold mt-4 tracking-tight">
          Even kort.
        </h2>
      </div>

      <div className="space-y-2">
        {faqs.map((faq, i) => (
          <FaqItem key={i} q={faq.q} a={faq.a} />
        ))}
      </div>
    </section>
  );
}

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="card overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-5 text-left hover:bg-bg-3 transition-colors"
      >
        <span className="font-medium pr-4">{q}</span>
        {open ? (
          <Minus size={18} className="text-ink-3 shrink-0" />
        ) : (
          <Plus size={18} className="text-ink-3 shrink-0" />
        )}
      </button>
      {open && (
        <div className="px-5 pb-5 text-ink-2 text-sm leading-relaxed">{a}</div>
      )}
    </div>
  );
}
